// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: syncfollow/syncfollow.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { EchoRequest, EchoResponse } from "../common/echo";
import { PathId } from "../schema_path/path_id";
import { SchemaType, schemaTypeFromJSON, schemaTypeToJSON } from "../schema_path/schema_path";
import { DataSeries } from "./syncfollow_threadlist";

export const protobufPackage = "syncfollow";

export enum ClientType {
  CLIENT_UNSPECIFIED = 0,
  LIRA = 1,
  FRED = 2,
  RUDDER = 3,
  AZIMUTH = 4,
  SEXTANT = 5,
  BILGE = 6,
  CONFIGD = 7,
  BRIG = 8,
  KRANG = 9,
  OTHER = 10,
  MIZZEN = 11,
  PERISCOPE = 12,
  UNRECOGNIZED = -1,
}

export function clientTypeFromJSON(object: any): ClientType {
  switch (object) {
    case 0:
    case "CLIENT_UNSPECIFIED":
      return ClientType.CLIENT_UNSPECIFIED;
    case 1:
    case "LIRA":
      return ClientType.LIRA;
    case 2:
    case "FRED":
      return ClientType.FRED;
    case 3:
    case "RUDDER":
      return ClientType.RUDDER;
    case 4:
    case "AZIMUTH":
      return ClientType.AZIMUTH;
    case 5:
    case "SEXTANT":
      return ClientType.SEXTANT;
    case 6:
    case "BILGE":
      return ClientType.BILGE;
    case 7:
    case "CONFIGD":
      return ClientType.CONFIGD;
    case 8:
    case "BRIG":
      return ClientType.BRIG;
    case 9:
    case "KRANG":
      return ClientType.KRANG;
    case 10:
    case "OTHER":
      return ClientType.OTHER;
    case 11:
    case "MIZZEN":
      return ClientType.MIZZEN;
    case 12:
    case "PERISCOPE":
      return ClientType.PERISCOPE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ClientType.UNRECOGNIZED;
  }
}

export function clientTypeToJSON(object: ClientType): string {
  switch (object) {
    case ClientType.CLIENT_UNSPECIFIED:
      return "CLIENT_UNSPECIFIED";
    case ClientType.LIRA:
      return "LIRA";
    case ClientType.FRED:
      return "FRED";
    case ClientType.RUDDER:
      return "RUDDER";
    case ClientType.AZIMUTH:
      return "AZIMUTH";
    case ClientType.SEXTANT:
      return "SEXTANT";
    case ClientType.BILGE:
      return "BILGE";
    case ClientType.CONFIGD:
      return "CONFIGD";
    case ClientType.BRIG:
      return "BRIG";
    case ClientType.KRANG:
      return "KRANG";
    case ClientType.OTHER:
      return "OTHER";
    case ClientType.MIZZEN:
      return "MIZZEN";
    case ClientType.PERISCOPE:
      return "PERISCOPE";
    case ClientType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ErrorCode {
  ERR_UNSPECIFIED = 0,
  ERR_DESERIALIZATION_ERROR = 1,
  ERR_UNSUPPORTED_TYPE = 2,
  ERR_UNKNOWN_ID = 3,
  ERR_MISSING_ID = 4,
  ERR_SERVER_REJECTED = 5,
  ERR_FORBIDDEN = 6,
  ERR_UNAUTHORIZED = 7,
  ERR_MAX_SYNCS_REACHED = 8,
  ERR_INVALID_FILTER = 9,
  ERR_BULK_DATA_LENGTH_MISMATCH = 10,
  ERR_BULK_DATA_STORAGE = 11,
  ERR_BULK_DATA_CHECKSUM_MISMATCH = 12,
  ERR_OBJECT_REASSIGNED = 13,
  ERR_BAD_QUERY_FOR_TYPE = 14,
  ERR_SFQL_PARSE_FAIL = 15,
  ERR_REFRESH_CLAIMS = 16,
  UNRECOGNIZED = -1,
}

export function errorCodeFromJSON(object: any): ErrorCode {
  switch (object) {
    case 0:
    case "ERR_UNSPECIFIED":
      return ErrorCode.ERR_UNSPECIFIED;
    case 1:
    case "ERR_DESERIALIZATION_ERROR":
      return ErrorCode.ERR_DESERIALIZATION_ERROR;
    case 2:
    case "ERR_UNSUPPORTED_TYPE":
      return ErrorCode.ERR_UNSUPPORTED_TYPE;
    case 3:
    case "ERR_UNKNOWN_ID":
      return ErrorCode.ERR_UNKNOWN_ID;
    case 4:
    case "ERR_MISSING_ID":
      return ErrorCode.ERR_MISSING_ID;
    case 5:
    case "ERR_SERVER_REJECTED":
      return ErrorCode.ERR_SERVER_REJECTED;
    case 6:
    case "ERR_FORBIDDEN":
      return ErrorCode.ERR_FORBIDDEN;
    case 7:
    case "ERR_UNAUTHORIZED":
      return ErrorCode.ERR_UNAUTHORIZED;
    case 8:
    case "ERR_MAX_SYNCS_REACHED":
      return ErrorCode.ERR_MAX_SYNCS_REACHED;
    case 9:
    case "ERR_INVALID_FILTER":
      return ErrorCode.ERR_INVALID_FILTER;
    case 10:
    case "ERR_BULK_DATA_LENGTH_MISMATCH":
      return ErrorCode.ERR_BULK_DATA_LENGTH_MISMATCH;
    case 11:
    case "ERR_BULK_DATA_STORAGE":
      return ErrorCode.ERR_BULK_DATA_STORAGE;
    case 12:
    case "ERR_BULK_DATA_CHECKSUM_MISMATCH":
      return ErrorCode.ERR_BULK_DATA_CHECKSUM_MISMATCH;
    case 13:
    case "ERR_OBJECT_REASSIGNED":
      return ErrorCode.ERR_OBJECT_REASSIGNED;
    case 14:
    case "ERR_BAD_QUERY_FOR_TYPE":
      return ErrorCode.ERR_BAD_QUERY_FOR_TYPE;
    case 15:
    case "ERR_SFQL_PARSE_FAIL":
      return ErrorCode.ERR_SFQL_PARSE_FAIL;
    case 16:
    case "ERR_REFRESH_CLAIMS":
      return ErrorCode.ERR_REFRESH_CLAIMS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ErrorCode.UNRECOGNIZED;
  }
}

export function errorCodeToJSON(object: ErrorCode): string {
  switch (object) {
    case ErrorCode.ERR_UNSPECIFIED:
      return "ERR_UNSPECIFIED";
    case ErrorCode.ERR_DESERIALIZATION_ERROR:
      return "ERR_DESERIALIZATION_ERROR";
    case ErrorCode.ERR_UNSUPPORTED_TYPE:
      return "ERR_UNSUPPORTED_TYPE";
    case ErrorCode.ERR_UNKNOWN_ID:
      return "ERR_UNKNOWN_ID";
    case ErrorCode.ERR_MISSING_ID:
      return "ERR_MISSING_ID";
    case ErrorCode.ERR_SERVER_REJECTED:
      return "ERR_SERVER_REJECTED";
    case ErrorCode.ERR_FORBIDDEN:
      return "ERR_FORBIDDEN";
    case ErrorCode.ERR_UNAUTHORIZED:
      return "ERR_UNAUTHORIZED";
    case ErrorCode.ERR_MAX_SYNCS_REACHED:
      return "ERR_MAX_SYNCS_REACHED";
    case ErrorCode.ERR_INVALID_FILTER:
      return "ERR_INVALID_FILTER";
    case ErrorCode.ERR_BULK_DATA_LENGTH_MISMATCH:
      return "ERR_BULK_DATA_LENGTH_MISMATCH";
    case ErrorCode.ERR_BULK_DATA_STORAGE:
      return "ERR_BULK_DATA_STORAGE";
    case ErrorCode.ERR_BULK_DATA_CHECKSUM_MISMATCH:
      return "ERR_BULK_DATA_CHECKSUM_MISMATCH";
    case ErrorCode.ERR_OBJECT_REASSIGNED:
      return "ERR_OBJECT_REASSIGNED";
    case ErrorCode.ERR_BAD_QUERY_FOR_TYPE:
      return "ERR_BAD_QUERY_FOR_TYPE";
    case ErrorCode.ERR_SFQL_PARSE_FAIL:
      return "ERR_SFQL_PARSE_FAIL";
    case ErrorCode.ERR_REFRESH_CLAIMS:
      return "ERR_REFRESH_CLAIMS";
    case ErrorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum FilterOp {
  UNSPECIFIED = 0,
  EQ = 1,
  NOT_EQ = 2,
  STARTS_WITH = 3,
  ENDS_WITH = 4,
  GT = 5,
  GT_EQ = 6,
  LT = 7,
  LT_EQ = 8,
  CONTAINS = 9,
  CONTAINED_BY = 10,
  UNRECOGNIZED = -1,
}

export function filterOpFromJSON(object: any): FilterOp {
  switch (object) {
    case 0:
    case "UNSPECIFIED":
      return FilterOp.UNSPECIFIED;
    case 1:
    case "EQ":
      return FilterOp.EQ;
    case 2:
    case "NOT_EQ":
      return FilterOp.NOT_EQ;
    case 3:
    case "STARTS_WITH":
      return FilterOp.STARTS_WITH;
    case 4:
    case "ENDS_WITH":
      return FilterOp.ENDS_WITH;
    case 5:
    case "GT":
      return FilterOp.GT;
    case 6:
    case "GT_EQ":
      return FilterOp.GT_EQ;
    case 7:
    case "LT":
      return FilterOp.LT;
    case 8:
    case "LT_EQ":
      return FilterOp.LT_EQ;
    case 9:
    case "CONTAINS":
      return FilterOp.CONTAINS;
    case 10:
    case "CONTAINED_BY":
      return FilterOp.CONTAINED_BY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FilterOp.UNRECOGNIZED;
  }
}

export function filterOpToJSON(object: FilterOp): string {
  switch (object) {
    case FilterOp.UNSPECIFIED:
      return "UNSPECIFIED";
    case FilterOp.EQ:
      return "EQ";
    case FilterOp.NOT_EQ:
      return "NOT_EQ";
    case FilterOp.STARTS_WITH:
      return "STARTS_WITH";
    case FilterOp.ENDS_WITH:
      return "ENDS_WITH";
    case FilterOp.GT:
      return "GT";
    case FilterOp.GT_EQ:
      return "GT_EQ";
    case FilterOp.LT:
      return "LT";
    case FilterOp.LT_EQ:
      return "LT_EQ";
    case FilterOp.CONTAINS:
      return "CONTAINS";
    case FilterOp.CONTAINED_BY:
      return "CONTAINED_BY";
    case FilterOp.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum UpdateRate {
  NONE = 0,
  INTERACTIVE = 1,
  PAGE_BACKGROUND = 2,
  GLACIAL = 3,
  UNRECOGNIZED = -1,
}

export function updateRateFromJSON(object: any): UpdateRate {
  switch (object) {
    case 0:
    case "NONE":
      return UpdateRate.NONE;
    case 1:
    case "INTERACTIVE":
      return UpdateRate.INTERACTIVE;
    case 2:
    case "PAGE_BACKGROUND":
      return UpdateRate.PAGE_BACKGROUND;
    case 3:
    case "GLACIAL":
      return UpdateRate.GLACIAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UpdateRate.UNRECOGNIZED;
  }
}

export function updateRateToJSON(object: UpdateRate): string {
  switch (object) {
    case UpdateRate.NONE:
      return "NONE";
    case UpdateRate.INTERACTIVE:
      return "INTERACTIVE";
    case UpdateRate.PAGE_BACKGROUND:
      return "PAGE_BACKGROUND";
    case UpdateRate.GLACIAL:
      return "GLACIAL";
    case UpdateRate.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ConnectionScope {
  CONNECTION_SCOPE_UNKNOWN = 0,
  CONNECTION_SCOPE_FABRIC = 1,
  CONNECTION_SCOPE_ORG = 2,
  CONNECTION_SCOPE_OBJECT = 3,
  UNRECOGNIZED = -1,
}

export function connectionScopeFromJSON(object: any): ConnectionScope {
  switch (object) {
    case 0:
    case "CONNECTION_SCOPE_UNKNOWN":
      return ConnectionScope.CONNECTION_SCOPE_UNKNOWN;
    case 1:
    case "CONNECTION_SCOPE_FABRIC":
      return ConnectionScope.CONNECTION_SCOPE_FABRIC;
    case 2:
    case "CONNECTION_SCOPE_ORG":
      return ConnectionScope.CONNECTION_SCOPE_ORG;
    case 3:
    case "CONNECTION_SCOPE_OBJECT":
      return ConnectionScope.CONNECTION_SCOPE_OBJECT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConnectionScope.UNRECOGNIZED;
  }
}

export function connectionScopeToJSON(object: ConnectionScope): string {
  switch (object) {
    case ConnectionScope.CONNECTION_SCOPE_UNKNOWN:
      return "CONNECTION_SCOPE_UNKNOWN";
    case ConnectionScope.CONNECTION_SCOPE_FABRIC:
      return "CONNECTION_SCOPE_FABRIC";
    case ConnectionScope.CONNECTION_SCOPE_ORG:
      return "CONNECTION_SCOPE_ORG";
    case ConnectionScope.CONNECTION_SCOPE_OBJECT:
      return "CONNECTION_SCOPE_OBJECT";
    case ConnectionScope.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QueryType {
  Invalid = 0,
  Sync = 1,
  Follow = 2,
  SyncAndFollow = 3,
  Stop = 4,
  UNRECOGNIZED = -1,
}

export function queryTypeFromJSON(object: any): QueryType {
  switch (object) {
    case 0:
    case "Invalid":
      return QueryType.Invalid;
    case 1:
    case "Sync":
      return QueryType.Sync;
    case 2:
    case "Follow":
      return QueryType.Follow;
    case 3:
    case "SyncAndFollow":
      return QueryType.SyncAndFollow;
    case 4:
    case "Stop":
      return QueryType.Stop;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QueryType.UNRECOGNIZED;
  }
}

export function queryTypeToJSON(object: QueryType): string {
  switch (object) {
    case QueryType.Invalid:
      return "Invalid";
    case QueryType.Sync:
      return "Sync";
    case QueryType.Follow:
      return "Follow";
    case QueryType.SyncAndFollow:
      return "SyncAndFollow";
    case QueryType.Stop:
      return "Stop";
    case QueryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MarkerType {
  None = 0,
  /** StartOfSync - Indicates the start of a sync section */
  StartOfSync = 1,
  /** EndOfSync - Indicates the end of the sync section */
  EndOfSync = 2,
  /** StartOfFollow - Indicates the start of a follow section */
  StartOfFollow = 3,
  /** UpToDate - Indicates the follow has caught up with the tail of the threadlist */
  UpToDate = 4,
  /** ResumeFailed - Indicates that the resume failed, the client should re-request a full sync */
  ResumeFailed = 5,
  /** StillAlive - Indicates the sync section is still alive */
  StillAlive = 6,
  /** SyncClosed - Indicates that the remote side will not send any more data for this sync ID */
  SyncClosed = 7,
  /** TotalCount - Indicates that the message is a total count message and Data.total_count has been filled in */
  TotalCount = 8,
  UNRECOGNIZED = -1,
}

export function markerTypeFromJSON(object: any): MarkerType {
  switch (object) {
    case 0:
    case "None":
      return MarkerType.None;
    case 1:
    case "StartOfSync":
      return MarkerType.StartOfSync;
    case 2:
    case "EndOfSync":
      return MarkerType.EndOfSync;
    case 3:
    case "StartOfFollow":
      return MarkerType.StartOfFollow;
    case 4:
    case "UpToDate":
      return MarkerType.UpToDate;
    case 5:
    case "ResumeFailed":
      return MarkerType.ResumeFailed;
    case 6:
    case "StillAlive":
      return MarkerType.StillAlive;
    case 7:
    case "SyncClosed":
      return MarkerType.SyncClosed;
    case 8:
    case "TotalCount":
      return MarkerType.TotalCount;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MarkerType.UNRECOGNIZED;
  }
}

export function markerTypeToJSON(object: MarkerType): string {
  switch (object) {
    case MarkerType.None:
      return "None";
    case MarkerType.StartOfSync:
      return "StartOfSync";
    case MarkerType.EndOfSync:
      return "EndOfSync";
    case MarkerType.StartOfFollow:
      return "StartOfFollow";
    case MarkerType.UpToDate:
      return "UpToDate";
    case MarkerType.ResumeFailed:
      return "ResumeFailed";
    case MarkerType.StillAlive:
      return "StillAlive";
    case MarkerType.SyncClosed:
      return "SyncClosed";
    case MarkerType.TotalCount:
      return "TotalCount";
    case MarkerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Message {
  /**
   * This could use oneof but the code gen does not support it
   * Only set one of these in each message
   */
  request: Request | undefined;
  data: Data | undefined;
  echoRequest: EchoRequest | undefined;
  echoResponse: EchoResponse | undefined;
  error: Error | undefined;
  hello: Hello | undefined;
  simpleRequest: SimpleRequest | undefined;
  bulkData: BulkData | undefined;
  options: Options | undefined;
}

export interface Hello {
  clientType: ClientType;
  clientId: string;
  /** sender's recommendation of what threadlist types that are not ready to sync */
  notReadyTypes: SchemaType[];
}

export interface Error {
  syncId: string;
  errorMessage: string;
  httpStatusCode: number;
  errorCode: ErrorCode;
  /** If fatal_error is set, the client should disconnect and wait at least backoff_time_ms before retrying */
  fatalError: boolean;
  backoffTimeMs: number;
}

export interface BodyFilter {
  /** field name to apply filter to. Can be a dotted path to apply to nested fields e.g. "metadata.name" */
  field: string;
  /** filter operation to apply */
  filterOp: FilterOp;
  /** value to apply to check against the index using the filterOp */
  filterVal: string;
}

export interface IndexFilter {
  /** index to apply filter to */
  index: SchemaType;
  /** filter operation to apply */
  filterOp: FilterOp;
  /** value to apply to check against the index using the filterOp */
  filterVal: string;
}

export interface ObjectFilter {
  /** a list of index filters to apply to the schema path. index filters are AND'd together. */
  indexFilters: IndexFilter[];
  /** a list of types to apply (or empty to apply to all types) */
  types: SchemaType[];
  /** a list of body filters to apply to any of the data fields in the object. body filters are AND'd together. */
  bodyFilters: BodyFilter[];
  /** a list of fields to include in the response. If empty, all fields are included. */
  includeFields: string[];
}

export interface MonitoredObjects {
  /** A list of arbitrary object IDs to monitor. */
  objectId: string[];
  /** A list of switch IDs to monitor.  If any switch IDs are not known, the request will fail. */
  switchId: string[];
  /** A list of fabric IDs to monitor. */
  fabricId: string[];
  /** A list of types to monitor.  Every object ID will monitor all types. */
  types: SchemaType[];
  /** optional list of filters to restrict which objects are monitored. object filters are OR'd together. */
  filters: ObjectFilter[];
  /** An optional list of override names for the object IDs corresponding to object_id. */
  destObjectId: string[];
}

export interface Request {
  /** Optional - can be set if the client wishes to multiplex multiple streaming result sets. Subsequent requests for the same sync_id will replace any previous sync for that ID */
  syncId: string;
  objects: MonitoredObjects[];
  query: QueryType;
  /** Indicates the offset to resume from for each type. If any single resume_offset cannot be applied then the server will respond with a Data message with a marker of ResumeFailed, client is responsible for re-requesting a full sync */
  resumeOffsets: StreamOffset[];
  /** Indicates that the client wants the path_string field populated for telemetry items. */
  includePathString: boolean;
  boost: BoostRequest[];
  /** Limit this syncfollow to at most n items. Items are ordered by schema path. Note this means the set is dynamic over time. */
  limitN: number;
  /** Start the limit from this path_id. Allows for pagination. */
  limitStart:
    | PathId
    | undefined;
  /** SFQL format query string. Can be used in place of objects, query, limit_n and limit_start. */
  sfql: string;
  /** Set this to only return data for lists that exist at the time the query starts. */
  existingListsOnly: boolean;
  /** Set this to periodically resync on this schedule. After the follow phase catches up, the server waits this interval then performs a full resync cycle (StartOfSync, data, EndOfSync) before returning to the follow phase. */
  resyncIntervalSeconds: number;
}

/** SimpleRequest is a simplified version of Request that allows only a SyncAndFollow query for a single object_id and type */
export interface SimpleRequest {
  /** Optional - can be set if the client wishes to multiplex multiple streaming result sets. Subsequent requests for the same sync_id will replace any previous sync for that ID */
  syncId: string;
  /** An arbitrary object ID, together with type idenfifies a single threadlist to monitor. */
  objectId: string;
  /** A single type, together with object_id idenfifies a single threadlist to monitor. */
  type: SchemaType;
  /** Limit this syncfollow to at most n items. Items are ordered by schema path. Note this means the set is dynamic over time. */
  limitN: number;
  /** Start the limit from this path_id. Allows for pagination. */
  limitStart: PathId | undefined;
}

export interface BoostRequest {
  /** A list of arbitrary object IDs to boost data collection for */
  objectId: string[];
  /** A list of types to boost for all given object IDs */
  types: SchemaType[];
  /** Rate (items/s) at which to process data */
  rate: number;
  /** Maximum burst size for data processing */
  capacity: number;
  /** Symbolic rate configuration, alternative to specifying (rate, capacity) above */
  updateRate: UpdateRate;
}

export interface Options {
  syncId: string;
  boost: BoostRequest[];
  /** Fabric ID to apply the active worker status to. */
  fabricId: string;
  /** Set to the ID of an active worker to remove from the set of active workers. */
  clearActiveWorker: string;
  /** Set to the ID of an active worker to add to the set of active workers. */
  setActiveWorker: string;
}

export interface StreamOffset {
  objectId: string;
  type: SchemaType;
  instance: number;
  offset: string;
}

export interface Data {
  /** Refers back to the sync_id that was set in the request */
  syncId: string;
  /** The data points */
  series:
    | DataSeries
    | undefined;
  /** Start/end of sync marker */
  marker: MarkerType;
  /** Monotonically increasing sequence number for sends on this sync_id. If there are any gaps seen at the receiving end then it should close the connection. */
  sequence: string;
  /** The total number of items in all the lists that have been requested. Only set when a limit filter was specified, so the caller knows the total set size despite receiving only a limited number of items from that set. */
  totalCount: string;
}

export interface BulkData {
  /** Refers back to the sync_id that was set in the request. This must be interpreted by the receiver to determine where to route the bulk data. */
  syncId: string;
  /** The length of the following bulk data in bytes */
  length: number;
  /** 32-byte SHA-256 checksum of the bulk data. Optional but if set MUST be 32 bytes long. */
  checksum: Uint8Array;
}

function createBaseMessage(): Message {
  return {
    request: undefined,
    data: undefined,
    echoRequest: undefined,
    echoResponse: undefined,
    error: undefined,
    hello: undefined,
    simpleRequest: undefined,
    bulkData: undefined,
    options: undefined,
  };
}

export const Message: MessageFns<Message> = {
  encode(message: Message, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.request !== undefined) {
      Request.encode(message.request, writer.uint32(10).fork()).join();
    }
    if (message.data !== undefined) {
      Data.encode(message.data, writer.uint32(18).fork()).join();
    }
    if (message.echoRequest !== undefined) {
      EchoRequest.encode(message.echoRequest, writer.uint32(26).fork()).join();
    }
    if (message.echoResponse !== undefined) {
      EchoResponse.encode(message.echoResponse, writer.uint32(34).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(42).fork()).join();
    }
    if (message.hello !== undefined) {
      Hello.encode(message.hello, writer.uint32(50).fork()).join();
    }
    if (message.simpleRequest !== undefined) {
      SimpleRequest.encode(message.simpleRequest, writer.uint32(66).fork()).join();
    }
    if (message.bulkData !== undefined) {
      BulkData.encode(message.bulkData, writer.uint32(74).fork()).join();
    }
    if (message.options !== undefined) {
      Options.encode(message.options, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Message {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.request = Request.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = Data.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.echoRequest = EchoRequest.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.echoResponse = EchoResponse.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.hello = Hello.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.simpleRequest = SimpleRequest.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.bulkData = BulkData.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.options = Options.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Message {
    return {
      request: isSet(object.request) ? Request.fromJSON(object.request) : undefined,
      data: isSet(object.data) ? Data.fromJSON(object.data) : undefined,
      echoRequest: isSet(object.echoRequest) ? EchoRequest.fromJSON(object.echoRequest) : undefined,
      echoResponse: isSet(object.echoResponse) ? EchoResponse.fromJSON(object.echoResponse) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
      hello: isSet(object.hello) ? Hello.fromJSON(object.hello) : undefined,
      simpleRequest: isSet(object.simpleRequest) ? SimpleRequest.fromJSON(object.simpleRequest) : undefined,
      bulkData: isSet(object.bulkData) ? BulkData.fromJSON(object.bulkData) : undefined,
      options: isSet(object.options) ? Options.fromJSON(object.options) : undefined,
    };
  },

  toJSON(message: Message): unknown {
    const obj: any = {};
    if (message.request !== undefined) {
      obj.request = Request.toJSON(message.request);
    }
    if (message.data !== undefined) {
      obj.data = Data.toJSON(message.data);
    }
    if (message.echoRequest !== undefined) {
      obj.echoRequest = EchoRequest.toJSON(message.echoRequest);
    }
    if (message.echoResponse !== undefined) {
      obj.echoResponse = EchoResponse.toJSON(message.echoResponse);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    if (message.hello !== undefined) {
      obj.hello = Hello.toJSON(message.hello);
    }
    if (message.simpleRequest !== undefined) {
      obj.simpleRequest = SimpleRequest.toJSON(message.simpleRequest);
    }
    if (message.bulkData !== undefined) {
      obj.bulkData = BulkData.toJSON(message.bulkData);
    }
    if (message.options !== undefined) {
      obj.options = Options.toJSON(message.options);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Message>, I>>(base?: I): Message {
    return Message.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Message>, I>>(object: I): Message {
    const message = createBaseMessage();
    message.request = (object.request !== undefined && object.request !== null)
      ? Request.fromPartial(object.request)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null) ? Data.fromPartial(object.data) : undefined;
    message.echoRequest = (object.echoRequest !== undefined && object.echoRequest !== null)
      ? EchoRequest.fromPartial(object.echoRequest)
      : undefined;
    message.echoResponse = (object.echoResponse !== undefined && object.echoResponse !== null)
      ? EchoResponse.fromPartial(object.echoResponse)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    message.hello = (object.hello !== undefined && object.hello !== null) ? Hello.fromPartial(object.hello) : undefined;
    message.simpleRequest = (object.simpleRequest !== undefined && object.simpleRequest !== null)
      ? SimpleRequest.fromPartial(object.simpleRequest)
      : undefined;
    message.bulkData = (object.bulkData !== undefined && object.bulkData !== null)
      ? BulkData.fromPartial(object.bulkData)
      : undefined;
    message.options = (object.options !== undefined && object.options !== null)
      ? Options.fromPartial(object.options)
      : undefined;
    return message;
  },
};

function createBaseHello(): Hello {
  return { clientType: 0, clientId: "", notReadyTypes: [] };
}

export const Hello: MessageFns<Hello> = {
  encode(message: Hello, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clientType !== 0) {
      writer.uint32(8).int32(message.clientType);
    }
    if (message.clientId !== "") {
      writer.uint32(18).string(message.clientId);
    }
    writer.uint32(26).fork();
    for (const v of message.notReadyTypes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Hello {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHello();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.clientType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.clientId = reader.string();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.notReadyTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.notReadyTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Hello {
    return {
      clientType: isSet(object.clientType) ? clientTypeFromJSON(object.clientType) : 0,
      clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : "",
      notReadyTypes: globalThis.Array.isArray(object?.notReadyTypes)
        ? object.notReadyTypes.map((e: any) => schemaTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: Hello): unknown {
    const obj: any = {};
    if (message.clientType !== 0) {
      obj.clientType = clientTypeToJSON(message.clientType);
    }
    if (message.clientId !== "") {
      obj.clientId = message.clientId;
    }
    if (message.notReadyTypes?.length) {
      obj.notReadyTypes = message.notReadyTypes.map((e) => schemaTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Hello>, I>>(base?: I): Hello {
    return Hello.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Hello>, I>>(object: I): Hello {
    const message = createBaseHello();
    message.clientType = object.clientType ?? 0;
    message.clientId = object.clientId ?? "";
    message.notReadyTypes = object.notReadyTypes?.map((e) => e) || [];
    return message;
  },
};

function createBaseError(): Error {
  return { syncId: "", errorMessage: "", httpStatusCode: 0, errorCode: 0, fatalError: false, backoffTimeMs: 0 };
}

export const Error: MessageFns<Error> = {
  encode(message: Error, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.syncId !== "") {
      writer.uint32(10).string(message.syncId);
    }
    if (message.errorMessage !== "") {
      writer.uint32(18).string(message.errorMessage);
    }
    if (message.httpStatusCode !== 0) {
      writer.uint32(24).uint32(message.httpStatusCode);
    }
    if (message.errorCode !== 0) {
      writer.uint32(32).int32(message.errorCode);
    }
    if (message.fatalError !== false) {
      writer.uint32(40).bool(message.fatalError);
    }
    if (message.backoffTimeMs !== 0) {
      writer.uint32(48).uint32(message.backoffTimeMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Error {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.syncId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.httpStatusCode = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.errorCode = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.fatalError = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.backoffTimeMs = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Error {
    return {
      syncId: isSet(object.syncId) ? globalThis.String(object.syncId) : "",
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
      httpStatusCode: isSet(object.httpStatusCode) ? globalThis.Number(object.httpStatusCode) : 0,
      errorCode: isSet(object.errorCode) ? errorCodeFromJSON(object.errorCode) : 0,
      fatalError: isSet(object.fatalError) ? globalThis.Boolean(object.fatalError) : false,
      backoffTimeMs: isSet(object.backoffTimeMs) ? globalThis.Number(object.backoffTimeMs) : 0,
    };
  },

  toJSON(message: Error): unknown {
    const obj: any = {};
    if (message.syncId !== "") {
      obj.syncId = message.syncId;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    if (message.httpStatusCode !== 0) {
      obj.httpStatusCode = Math.round(message.httpStatusCode);
    }
    if (message.errorCode !== 0) {
      obj.errorCode = errorCodeToJSON(message.errorCode);
    }
    if (message.fatalError !== false) {
      obj.fatalError = message.fatalError;
    }
    if (message.backoffTimeMs !== 0) {
      obj.backoffTimeMs = Math.round(message.backoffTimeMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Error>, I>>(base?: I): Error {
    return Error.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Error>, I>>(object: I): Error {
    const message = createBaseError();
    message.syncId = object.syncId ?? "";
    message.errorMessage = object.errorMessage ?? "";
    message.httpStatusCode = object.httpStatusCode ?? 0;
    message.errorCode = object.errorCode ?? 0;
    message.fatalError = object.fatalError ?? false;
    message.backoffTimeMs = object.backoffTimeMs ?? 0;
    return message;
  },
};

function createBaseBodyFilter(): BodyFilter {
  return { field: "", filterOp: 0, filterVal: "" };
}

export const BodyFilter: MessageFns<BodyFilter> = {
  encode(message: BodyFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.field !== "") {
      writer.uint32(10).string(message.field);
    }
    if (message.filterOp !== 0) {
      writer.uint32(16).int32(message.filterOp);
    }
    if (message.filterVal !== "") {
      writer.uint32(26).string(message.filterVal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BodyFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBodyFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.field = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.filterOp = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.filterVal = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BodyFilter {
    return {
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      filterOp: isSet(object.filterOp) ? filterOpFromJSON(object.filterOp) : 0,
      filterVal: isSet(object.filterVal) ? globalThis.String(object.filterVal) : "",
    };
  },

  toJSON(message: BodyFilter): unknown {
    const obj: any = {};
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.filterOp !== 0) {
      obj.filterOp = filterOpToJSON(message.filterOp);
    }
    if (message.filterVal !== "") {
      obj.filterVal = message.filterVal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BodyFilter>, I>>(base?: I): BodyFilter {
    return BodyFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BodyFilter>, I>>(object: I): BodyFilter {
    const message = createBaseBodyFilter();
    message.field = object.field ?? "";
    message.filterOp = object.filterOp ?? 0;
    message.filterVal = object.filterVal ?? "";
    return message;
  },
};

function createBaseIndexFilter(): IndexFilter {
  return { index: 0, filterOp: 0, filterVal: "" };
}

export const IndexFilter: MessageFns<IndexFilter> = {
  encode(message: IndexFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.index !== 0) {
      writer.uint32(8).int32(message.index);
    }
    if (message.filterOp !== 0) {
      writer.uint32(16).int32(message.filterOp);
    }
    if (message.filterVal !== "") {
      writer.uint32(26).string(message.filterVal);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IndexFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndexFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.index = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.filterOp = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.filterVal = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IndexFilter {
    return {
      index: isSet(object.index) ? schemaTypeFromJSON(object.index) : 0,
      filterOp: isSet(object.filterOp) ? filterOpFromJSON(object.filterOp) : 0,
      filterVal: isSet(object.filterVal) ? globalThis.String(object.filterVal) : "",
    };
  },

  toJSON(message: IndexFilter): unknown {
    const obj: any = {};
    if (message.index !== 0) {
      obj.index = schemaTypeToJSON(message.index);
    }
    if (message.filterOp !== 0) {
      obj.filterOp = filterOpToJSON(message.filterOp);
    }
    if (message.filterVal !== "") {
      obj.filterVal = message.filterVal;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IndexFilter>, I>>(base?: I): IndexFilter {
    return IndexFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IndexFilter>, I>>(object: I): IndexFilter {
    const message = createBaseIndexFilter();
    message.index = object.index ?? 0;
    message.filterOp = object.filterOp ?? 0;
    message.filterVal = object.filterVal ?? "";
    return message;
  },
};

function createBaseObjectFilter(): ObjectFilter {
  return { indexFilters: [], types: [], bodyFilters: [], includeFields: [] };
}

export const ObjectFilter: MessageFns<ObjectFilter> = {
  encode(message: ObjectFilter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.indexFilters) {
      IndexFilter.encode(v!, writer.uint32(10).fork()).join();
    }
    writer.uint32(18).fork();
    for (const v of message.types) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.bodyFilters) {
      BodyFilter.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.includeFields) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObjectFilter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObjectFilter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.indexFilters.push(IndexFilter.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.types.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.types.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bodyFilters.push(BodyFilter.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.includeFields.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObjectFilter {
    return {
      indexFilters: globalThis.Array.isArray(object?.indexFilters)
        ? object.indexFilters.map((e: any) => IndexFilter.fromJSON(e))
        : [],
      types: globalThis.Array.isArray(object?.types) ? object.types.map((e: any) => schemaTypeFromJSON(e)) : [],
      bodyFilters: globalThis.Array.isArray(object?.bodyFilters)
        ? object.bodyFilters.map((e: any) => BodyFilter.fromJSON(e))
        : [],
      includeFields: globalThis.Array.isArray(object?.includeFields)
        ? object.includeFields.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ObjectFilter): unknown {
    const obj: any = {};
    if (message.indexFilters?.length) {
      obj.indexFilters = message.indexFilters.map((e) => IndexFilter.toJSON(e));
    }
    if (message.types?.length) {
      obj.types = message.types.map((e) => schemaTypeToJSON(e));
    }
    if (message.bodyFilters?.length) {
      obj.bodyFilters = message.bodyFilters.map((e) => BodyFilter.toJSON(e));
    }
    if (message.includeFields?.length) {
      obj.includeFields = message.includeFields;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObjectFilter>, I>>(base?: I): ObjectFilter {
    return ObjectFilter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObjectFilter>, I>>(object: I): ObjectFilter {
    const message = createBaseObjectFilter();
    message.indexFilters = object.indexFilters?.map((e) => IndexFilter.fromPartial(e)) || [];
    message.types = object.types?.map((e) => e) || [];
    message.bodyFilters = object.bodyFilters?.map((e) => BodyFilter.fromPartial(e)) || [];
    message.includeFields = object.includeFields?.map((e) => e) || [];
    return message;
  },
};

function createBaseMonitoredObjects(): MonitoredObjects {
  return { objectId: [], switchId: [], fabricId: [], types: [], filters: [], destObjectId: [] };
}

export const MonitoredObjects: MessageFns<MonitoredObjects> = {
  encode(message: MonitoredObjects, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.objectId) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.switchId) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.fabricId) {
      writer.uint32(26).string(v!);
    }
    writer.uint32(34).fork();
    for (const v of message.types) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.filters) {
      ObjectFilter.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.destObjectId) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MonitoredObjects {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMonitoredObjects();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.objectId.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchId.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId.push(reader.string());
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.types.push(reader.int32() as any);

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.types.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.filters.push(ObjectFilter.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.destObjectId.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MonitoredObjects {
    return {
      objectId: globalThis.Array.isArray(object?.objectId) ? object.objectId.map((e: any) => globalThis.String(e)) : [],
      switchId: globalThis.Array.isArray(object?.switchId) ? object.switchId.map((e: any) => globalThis.String(e)) : [],
      fabricId: globalThis.Array.isArray(object?.fabricId) ? object.fabricId.map((e: any) => globalThis.String(e)) : [],
      types: globalThis.Array.isArray(object?.types) ? object.types.map((e: any) => schemaTypeFromJSON(e)) : [],
      filters: globalThis.Array.isArray(object?.filters)
        ? object.filters.map((e: any) => ObjectFilter.fromJSON(e))
        : [],
      destObjectId: globalThis.Array.isArray(object?.destObjectId)
        ? object.destObjectId.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: MonitoredObjects): unknown {
    const obj: any = {};
    if (message.objectId?.length) {
      obj.objectId = message.objectId;
    }
    if (message.switchId?.length) {
      obj.switchId = message.switchId;
    }
    if (message.fabricId?.length) {
      obj.fabricId = message.fabricId;
    }
    if (message.types?.length) {
      obj.types = message.types.map((e) => schemaTypeToJSON(e));
    }
    if (message.filters?.length) {
      obj.filters = message.filters.map((e) => ObjectFilter.toJSON(e));
    }
    if (message.destObjectId?.length) {
      obj.destObjectId = message.destObjectId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MonitoredObjects>, I>>(base?: I): MonitoredObjects {
    return MonitoredObjects.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MonitoredObjects>, I>>(object: I): MonitoredObjects {
    const message = createBaseMonitoredObjects();
    message.objectId = object.objectId?.map((e) => e) || [];
    message.switchId = object.switchId?.map((e) => e) || [];
    message.fabricId = object.fabricId?.map((e) => e) || [];
    message.types = object.types?.map((e) => e) || [];
    message.filters = object.filters?.map((e) => ObjectFilter.fromPartial(e)) || [];
    message.destObjectId = object.destObjectId?.map((e) => e) || [];
    return message;
  },
};

function createBaseRequest(): Request {
  return {
    syncId: "",
    objects: [],
    query: 0,
    resumeOffsets: [],
    includePathString: false,
    boost: [],
    limitN: 0,
    limitStart: undefined,
    sfql: "",
    existingListsOnly: false,
    resyncIntervalSeconds: 0,
  };
}

export const Request: MessageFns<Request> = {
  encode(message: Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.syncId !== "") {
      writer.uint32(10).string(message.syncId);
    }
    for (const v of message.objects) {
      MonitoredObjects.encode(v!, writer.uint32(98).fork()).join();
    }
    if (message.query !== 0) {
      writer.uint32(48).int32(message.query);
    }
    for (const v of message.resumeOffsets) {
      StreamOffset.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.includePathString !== false) {
      writer.uint32(80).bool(message.includePathString);
    }
    for (const v of message.boost) {
      BoostRequest.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.limitN !== 0) {
      writer.uint32(112).uint32(message.limitN);
    }
    if (message.limitStart !== undefined) {
      PathId.encode(message.limitStart, writer.uint32(122).fork()).join();
    }
    if (message.sfql !== "") {
      writer.uint32(138).string(message.sfql);
    }
    if (message.existingListsOnly !== false) {
      writer.uint32(144).bool(message.existingListsOnly);
    }
    if (message.resyncIntervalSeconds !== 0) {
      writer.uint32(152).uint32(message.resyncIntervalSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.syncId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.objects.push(MonitoredObjects.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.query = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.resumeOffsets.push(StreamOffset.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.includePathString = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.boost.push(BoostRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.limitN = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.limitStart = PathId.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.sfql = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.existingListsOnly = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.resyncIntervalSeconds = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Request {
    return {
      syncId: isSet(object.syncId) ? globalThis.String(object.syncId) : "",
      objects: globalThis.Array.isArray(object?.objects)
        ? object.objects.map((e: any) => MonitoredObjects.fromJSON(e))
        : [],
      query: isSet(object.query) ? queryTypeFromJSON(object.query) : 0,
      resumeOffsets: globalThis.Array.isArray(object?.resumeOffsets)
        ? object.resumeOffsets.map((e: any) => StreamOffset.fromJSON(e))
        : [],
      includePathString: isSet(object.includePathString) ? globalThis.Boolean(object.includePathString) : false,
      boost: globalThis.Array.isArray(object?.boost) ? object.boost.map((e: any) => BoostRequest.fromJSON(e)) : [],
      limitN: isSet(object.limitN) ? globalThis.Number(object.limitN) : 0,
      limitStart: isSet(object.limitStart) ? PathId.fromJSON(object.limitStart) : undefined,
      sfql: isSet(object.sfql) ? globalThis.String(object.sfql) : "",
      existingListsOnly: isSet(object.existingListsOnly) ? globalThis.Boolean(object.existingListsOnly) : false,
      resyncIntervalSeconds: isSet(object.resyncIntervalSeconds) ? globalThis.Number(object.resyncIntervalSeconds) : 0,
    };
  },

  toJSON(message: Request): unknown {
    const obj: any = {};
    if (message.syncId !== "") {
      obj.syncId = message.syncId;
    }
    if (message.objects?.length) {
      obj.objects = message.objects.map((e) => MonitoredObjects.toJSON(e));
    }
    if (message.query !== 0) {
      obj.query = queryTypeToJSON(message.query);
    }
    if (message.resumeOffsets?.length) {
      obj.resumeOffsets = message.resumeOffsets.map((e) => StreamOffset.toJSON(e));
    }
    if (message.includePathString !== false) {
      obj.includePathString = message.includePathString;
    }
    if (message.boost?.length) {
      obj.boost = message.boost.map((e) => BoostRequest.toJSON(e));
    }
    if (message.limitN !== 0) {
      obj.limitN = Math.round(message.limitN);
    }
    if (message.limitStart !== undefined) {
      obj.limitStart = PathId.toJSON(message.limitStart);
    }
    if (message.sfql !== "") {
      obj.sfql = message.sfql;
    }
    if (message.existingListsOnly !== false) {
      obj.existingListsOnly = message.existingListsOnly;
    }
    if (message.resyncIntervalSeconds !== 0) {
      obj.resyncIntervalSeconds = Math.round(message.resyncIntervalSeconds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Request>, I>>(base?: I): Request {
    return Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Request>, I>>(object: I): Request {
    const message = createBaseRequest();
    message.syncId = object.syncId ?? "";
    message.objects = object.objects?.map((e) => MonitoredObjects.fromPartial(e)) || [];
    message.query = object.query ?? 0;
    message.resumeOffsets = object.resumeOffsets?.map((e) => StreamOffset.fromPartial(e)) || [];
    message.includePathString = object.includePathString ?? false;
    message.boost = object.boost?.map((e) => BoostRequest.fromPartial(e)) || [];
    message.limitN = object.limitN ?? 0;
    message.limitStart = (object.limitStart !== undefined && object.limitStart !== null)
      ? PathId.fromPartial(object.limitStart)
      : undefined;
    message.sfql = object.sfql ?? "";
    message.existingListsOnly = object.existingListsOnly ?? false;
    message.resyncIntervalSeconds = object.resyncIntervalSeconds ?? 0;
    return message;
  },
};

function createBaseSimpleRequest(): SimpleRequest {
  return { syncId: "", objectId: "", type: 0, limitN: 0, limitStart: undefined };
}

export const SimpleRequest: MessageFns<SimpleRequest> = {
  encode(message: SimpleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.syncId !== "") {
      writer.uint32(10).string(message.syncId);
    }
    if (message.objectId !== "") {
      writer.uint32(18).string(message.objectId);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    if (message.limitN !== 0) {
      writer.uint32(32).uint32(message.limitN);
    }
    if (message.limitStart !== undefined) {
      PathId.encode(message.limitStart, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SimpleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimpleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.syncId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.objectId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.limitN = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.limitStart = PathId.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimpleRequest {
    return {
      syncId: isSet(object.syncId) ? globalThis.String(object.syncId) : "",
      objectId: isSet(object.objectId) ? globalThis.String(object.objectId) : "",
      type: isSet(object.type) ? schemaTypeFromJSON(object.type) : 0,
      limitN: isSet(object.limitN) ? globalThis.Number(object.limitN) : 0,
      limitStart: isSet(object.limitStart) ? PathId.fromJSON(object.limitStart) : undefined,
    };
  },

  toJSON(message: SimpleRequest): unknown {
    const obj: any = {};
    if (message.syncId !== "") {
      obj.syncId = message.syncId;
    }
    if (message.objectId !== "") {
      obj.objectId = message.objectId;
    }
    if (message.type !== 0) {
      obj.type = schemaTypeToJSON(message.type);
    }
    if (message.limitN !== 0) {
      obj.limitN = Math.round(message.limitN);
    }
    if (message.limitStart !== undefined) {
      obj.limitStart = PathId.toJSON(message.limitStart);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimpleRequest>, I>>(base?: I): SimpleRequest {
    return SimpleRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimpleRequest>, I>>(object: I): SimpleRequest {
    const message = createBaseSimpleRequest();
    message.syncId = object.syncId ?? "";
    message.objectId = object.objectId ?? "";
    message.type = object.type ?? 0;
    message.limitN = object.limitN ?? 0;
    message.limitStart = (object.limitStart !== undefined && object.limitStart !== null)
      ? PathId.fromPartial(object.limitStart)
      : undefined;
    return message;
  },
};

function createBaseBoostRequest(): BoostRequest {
  return { objectId: [], types: [], rate: 0, capacity: 0, updateRate: 0 };
}

export const BoostRequest: MessageFns<BoostRequest> = {
  encode(message: BoostRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.objectId) {
      writer.uint32(10).string(v!);
    }
    writer.uint32(18).fork();
    for (const v of message.types) {
      writer.int32(v);
    }
    writer.join();
    if (message.rate !== 0) {
      writer.uint32(33).double(message.rate);
    }
    if (message.capacity !== 0) {
      writer.uint32(40).int32(message.capacity);
    }
    if (message.updateRate !== 0) {
      writer.uint32(48).int32(message.updateRate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BoostRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBoostRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.objectId.push(reader.string());
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.types.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.types.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.rate = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.capacity = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.updateRate = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BoostRequest {
    return {
      objectId: globalThis.Array.isArray(object?.objectId) ? object.objectId.map((e: any) => globalThis.String(e)) : [],
      types: globalThis.Array.isArray(object?.types) ? object.types.map((e: any) => schemaTypeFromJSON(e)) : [],
      rate: isSet(object.rate) ? globalThis.Number(object.rate) : 0,
      capacity: isSet(object.capacity) ? globalThis.Number(object.capacity) : 0,
      updateRate: isSet(object.updateRate) ? updateRateFromJSON(object.updateRate) : 0,
    };
  },

  toJSON(message: BoostRequest): unknown {
    const obj: any = {};
    if (message.objectId?.length) {
      obj.objectId = message.objectId;
    }
    if (message.types?.length) {
      obj.types = message.types.map((e) => schemaTypeToJSON(e));
    }
    if (message.rate !== 0) {
      obj.rate = message.rate;
    }
    if (message.capacity !== 0) {
      obj.capacity = Math.round(message.capacity);
    }
    if (message.updateRate !== 0) {
      obj.updateRate = updateRateToJSON(message.updateRate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BoostRequest>, I>>(base?: I): BoostRequest {
    return BoostRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BoostRequest>, I>>(object: I): BoostRequest {
    const message = createBaseBoostRequest();
    message.objectId = object.objectId?.map((e) => e) || [];
    message.types = object.types?.map((e) => e) || [];
    message.rate = object.rate ?? 0;
    message.capacity = object.capacity ?? 0;
    message.updateRate = object.updateRate ?? 0;
    return message;
  },
};

function createBaseOptions(): Options {
  return { syncId: "", boost: [], fabricId: "", clearActiveWorker: "", setActiveWorker: "" };
}

export const Options: MessageFns<Options> = {
  encode(message: Options, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.syncId !== "") {
      writer.uint32(10).string(message.syncId);
    }
    for (const v of message.boost) {
      BoostRequest.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.fabricId !== "") {
      writer.uint32(26).string(message.fabricId);
    }
    if (message.clearActiveWorker !== "") {
      writer.uint32(34).string(message.clearActiveWorker);
    }
    if (message.setActiveWorker !== "") {
      writer.uint32(42).string(message.setActiveWorker);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Options {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.syncId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.boost.push(BoostRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.clearActiveWorker = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.setActiveWorker = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Options {
    return {
      syncId: isSet(object.syncId) ? globalThis.String(object.syncId) : "",
      boost: globalThis.Array.isArray(object?.boost) ? object.boost.map((e: any) => BoostRequest.fromJSON(e)) : [],
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      clearActiveWorker: isSet(object.clearActiveWorker) ? globalThis.String(object.clearActiveWorker) : "",
      setActiveWorker: isSet(object.setActiveWorker) ? globalThis.String(object.setActiveWorker) : "",
    };
  },

  toJSON(message: Options): unknown {
    const obj: any = {};
    if (message.syncId !== "") {
      obj.syncId = message.syncId;
    }
    if (message.boost?.length) {
      obj.boost = message.boost.map((e) => BoostRequest.toJSON(e));
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.clearActiveWorker !== "") {
      obj.clearActiveWorker = message.clearActiveWorker;
    }
    if (message.setActiveWorker !== "") {
      obj.setActiveWorker = message.setActiveWorker;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Options>, I>>(base?: I): Options {
    return Options.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Options>, I>>(object: I): Options {
    const message = createBaseOptions();
    message.syncId = object.syncId ?? "";
    message.boost = object.boost?.map((e) => BoostRequest.fromPartial(e)) || [];
    message.fabricId = object.fabricId ?? "";
    message.clearActiveWorker = object.clearActiveWorker ?? "";
    message.setActiveWorker = object.setActiveWorker ?? "";
    return message;
  },
};

function createBaseStreamOffset(): StreamOffset {
  return { objectId: "", type: 0, instance: 0, offset: "0" };
}

export const StreamOffset: MessageFns<StreamOffset> = {
  encode(message: StreamOffset, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.objectId !== "") {
      writer.uint32(10).string(message.objectId);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.instance !== 0) {
      writer.uint32(24).uint32(message.instance);
    }
    if (message.offset !== "0") {
      writer.uint32(32).uint64(message.offset);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StreamOffset {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreamOffset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.objectId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.instance = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.offset = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StreamOffset {
    return {
      objectId: isSet(object.objectId) ? globalThis.String(object.objectId) : "",
      type: isSet(object.type) ? schemaTypeFromJSON(object.type) : 0,
      instance: isSet(object.instance) ? globalThis.Number(object.instance) : 0,
      offset: isSet(object.offset) ? globalThis.String(object.offset) : "0",
    };
  },

  toJSON(message: StreamOffset): unknown {
    const obj: any = {};
    if (message.objectId !== "") {
      obj.objectId = message.objectId;
    }
    if (message.type !== 0) {
      obj.type = schemaTypeToJSON(message.type);
    }
    if (message.instance !== 0) {
      obj.instance = Math.round(message.instance);
    }
    if (message.offset !== "0") {
      obj.offset = message.offset;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StreamOffset>, I>>(base?: I): StreamOffset {
    return StreamOffset.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StreamOffset>, I>>(object: I): StreamOffset {
    const message = createBaseStreamOffset();
    message.objectId = object.objectId ?? "";
    message.type = object.type ?? 0;
    message.instance = object.instance ?? 0;
    message.offset = object.offset ?? "0";
    return message;
  },
};

function createBaseData(): Data {
  return { syncId: "", series: undefined, marker: 0, sequence: "0", totalCount: "0" };
}

export const Data: MessageFns<Data> = {
  encode(message: Data, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.syncId !== "") {
      writer.uint32(10).string(message.syncId);
    }
    if (message.series !== undefined) {
      DataSeries.encode(message.series, writer.uint32(18).fork()).join();
    }
    if (message.marker !== 0) {
      writer.uint32(24).int32(message.marker);
    }
    if (message.sequence !== "0") {
      writer.uint32(32).uint64(message.sequence);
    }
    if (message.totalCount !== "0") {
      writer.uint32(40).uint64(message.totalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Data {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.syncId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.series = DataSeries.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.marker = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.sequence = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.totalCount = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Data {
    return {
      syncId: isSet(object.syncId) ? globalThis.String(object.syncId) : "",
      series: isSet(object.series) ? DataSeries.fromJSON(object.series) : undefined,
      marker: isSet(object.marker) ? markerTypeFromJSON(object.marker) : 0,
      sequence: isSet(object.sequence) ? globalThis.String(object.sequence) : "0",
      totalCount: isSet(object.totalCount) ? globalThis.String(object.totalCount) : "0",
    };
  },

  toJSON(message: Data): unknown {
    const obj: any = {};
    if (message.syncId !== "") {
      obj.syncId = message.syncId;
    }
    if (message.series !== undefined) {
      obj.series = DataSeries.toJSON(message.series);
    }
    if (message.marker !== 0) {
      obj.marker = markerTypeToJSON(message.marker);
    }
    if (message.sequence !== "0") {
      obj.sequence = message.sequence;
    }
    if (message.totalCount !== "0") {
      obj.totalCount = message.totalCount;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Data>, I>>(base?: I): Data {
    return Data.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Data>, I>>(object: I): Data {
    const message = createBaseData();
    message.syncId = object.syncId ?? "";
    message.series = (object.series !== undefined && object.series !== null)
      ? DataSeries.fromPartial(object.series)
      : undefined;
    message.marker = object.marker ?? 0;
    message.sequence = object.sequence ?? "0";
    message.totalCount = object.totalCount ?? "0";
    return message;
  },
};

function createBaseBulkData(): BulkData {
  return { syncId: "", length: 0, checksum: new Uint8Array(0) };
}

export const BulkData: MessageFns<BulkData> = {
  encode(message: BulkData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.syncId !== "") {
      writer.uint32(10).string(message.syncId);
    }
    if (message.length !== 0) {
      writer.uint32(16).uint32(message.length);
    }
    if (message.checksum.length !== 0) {
      writer.uint32(26).bytes(message.checksum);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BulkData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.syncId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.length = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.checksum = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkData {
    return {
      syncId: isSet(object.syncId) ? globalThis.String(object.syncId) : "",
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
      checksum: isSet(object.checksum) ? bytesFromBase64(object.checksum) : new Uint8Array(0),
    };
  },

  toJSON(message: BulkData): unknown {
    const obj: any = {};
    if (message.syncId !== "") {
      obj.syncId = message.syncId;
    }
    if (message.length !== 0) {
      obj.length = Math.round(message.length);
    }
    if (message.checksum.length !== 0) {
      obj.checksum = base64FromBytes(message.checksum);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkData>, I>>(base?: I): BulkData {
    return BulkData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkData>, I>>(object: I): BulkData {
    const message = createBaseBulkData();
    message.syncId = object.syncId ?? "";
    message.length = object.length ?? 0;
    message.checksum = object.checksum ?? new Uint8Array(0);
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
